var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIcCollectionsBlack(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 26,
    height: 22,
    viewBox: "0 0 26 22",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "#303D4D",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1.592 2.123v14.329h8.013c.912.218 1.454.522 2.344 1.727.889 1.205.666 2.2.788 3.05-.52-1.082-.985-1.792-1.397-2.13-.413-.339-1.14-.609-2.183-.81H0V2.123h1.592zm1.592 0h6.118c.77.234 1.384.496 1.843.786v12.356a8.572 8.572 0 0 0-1.17-.362l-.183-.043H3.184V2.123z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.675 2.318v13.268c-.47-.268-1.056-.476-1.758-.64l-.26-.03H2.76V.025h6.815c.519 0 1.124.542 1.379.816.262.281.721.937.721 1.478zM16.982 2.123v8.491l3.371-3.184 2.998 3.184V2.123h2.123v16.166h-9.157c-1.043.201-1.77.471-2.183.81-.412.338-.878 1.048-1.397 2.13V5.181c.298-.879.683-1.529 1.155-1.95.472-.42 1.232-.79 2.28-1.11h.81zm1.062 0h4.245v5.063L21.19 5.947a1.097 1.097 0 0 0-1.617-.05l-1.53 1.533V2.123z"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcCollectionsBlack);
export default __webpack_public_path__ + "static/media/ic-collections-black.f727a5785041cba5bccac6f0ecd6ef69.svg";
export { ForwardRef as ReactComponent };